import { NgModule } from "@angular/core";
import { CustomAsideSectionComponent } from "./custom-aside-section/custom-aside-section.component";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MobiOfficeUiModule, MaterialModule } from "@mobi-office-ui";

@NgModule({
  declarations: [CustomAsideSectionComponent],
  imports: [CommonModule, MobiOfficeUiModule, MaterialModule, FormsModule],
  exports: [MobiOfficeUiModule, MaterialModule, DatePipe, CustomAsideSectionComponent],
  providers: [],
})
export class SharedModule {}
